export const FETCH_REVIEWS_REQUEST = 'FETCH_REVIEWS_REQUEST';
export const FETCH_REVIEWS_SUCCESS = 'FETCH_REVIEWS_SUCCESS';
export const FETCH_REVIEWS_FAILURE = 'FETCH_REVIEWS_FAILURE';

export const BANNED_OR_UNBANNED_REVIEW_REQUEST = 'BANNED_OR_UNBANNED_REVIEW_REQUEST';
export const BANNED_OR_UNBANNED_REVIEW_SUCCESS = 'BANNED_OR_UNBANNED_REVIEW_SUCCESS';
export const BANNED_OR_UNBANNED_REVIEW_FAILURE = 'BANNED_OR_UNBANNED_REVIEW_FAILURE';
